import { render, staticRenderFns } from "./Kesehatan.vue?vue&type=template&id=9a6ef1f6"
import script from "./Kesehatan.vue?vue&type=script&lang=js"
export * from "./Kesehatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports